<template>
	<div class="register-detail">
		<div class="go-back-btn cursor-point" @click="$router.go(-1)">
			<icon-font type="icon-fanhui" />返回
		</div>
		<div style="margin-left:20px">
			<div class="content-box hp_cz_center">
				<div class="hospitalImg hp_center">
					<img
						v-if="infoData.image"
						:src="base_url + infoData.image"
						alt
					/>
					<img v-else src="@/assets/default-img/doctor.png" alt />
				</div>
				<div class="doc-name">{{ infoData.doctorName }}</div>
				<div style="margin-right:60px;">{{ infoData.doctorTitle }}</div>
				<div style="color:#999">
					{{ infoData.hospitalName }} {{ infoData.deptName }}
				</div>
			</div>
			<div class="content-box">
				<div>就诊人：{{ infoData.recordName }}</div>
				<div>挂号费：{{ infoData.payAmount }}元</div>
				<div>就诊时间：{{ infoData.treatTime }}</div>
				<div v-if="infoData.serialNo">
					就诊序号：{{ infoData.serialNo }}
				</div>
				<div v-if="showYYFrom">
					预约来源：{{ infoData.yuyuefrom }}
				</div>
			</div>
			<div class="content-box">
				<div class="box-title">订单详情</div>
				<div>订单号：{{ infoData.code }}</div>
				<div>下单时间：{{ infoData.bizTime }}</div>
				<div v-if="infoData.payTime">
					支付时间：{{ infoData.payTime }}
				</div>
				<div v-if="infoData.payMethod">
					支付方式：{{ infoData.payMethod | payMethod }}
				</div>
			</div>
			<div class="content-box">
				<div class="box-title">就诊须知</div>
				<pre v-if="reserveInfo"
					>{{ reserveInfo }}
        </pre
				>
				<pre v-else>
1、本系统要求实名挂号，且需支付挂号费；
2、每个身份证挂号限制：限同时挂号三次，每个科室限挂一次，每月6次；
3.请携带身份证、就诊卡前往对应科室就诊、检验、治疗、取药等；
4、如需取消预约，请在预约时间24小时前在“我-我的挂号”申请取消、退款；当天当班不就诊，医院不再安排就诊及退费；
5、如需索取发票，请咨询医院挂号处。
        </pre
				>
			</div>
		</div>
	</div>
</template>
<script>
import { getOrderDetail,checkYuyueFrom } from '@/api/payment'
import { getHospitalDetail } from '@/api/registered'
export default {
	data() {
		return {
			infoData: {},
			reserveInfo: '',
			showYYFrom:false
		}
	},
	created() {
		this.getData()

	},
	methods: {
		async getData() {
			let data = {}
			this.$route.query.pageType == 'msg' ? (data.pageType = 'msg') : ''
			checkYuyueFrom({hospId:this.$route.query.hospId}).then(res=>{
				this.showYYFrom = res.data
			})

			let res = await getOrderDetail(this.$route.query.id, data)
			this.infoData = res.data || {}
			if (res.data.hospitalId) {
				let rs = await getHospitalDetail(res.data.hospitalId)
				this.reserveInfo = rs.data.reserveInfo
			}
		},
	},
	mounted() {},
}
</script>
<style lang="less" scoped>
.register-detail {
	.go-back-btn {
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3385ed;
		i {
			font-size: 20px;
		}
	}
	.content-box {
		font-size: 20px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #666666;
		line-height: 34px;
		padding: 15px 0;
		padding-left: 6px;
		border-bottom: 1px solid #dddddd;
		.hospitalImg {
			width: 62px;
			height: 62px;
			margin-right: 25px;
			overflow: hidden;
			border-radius: 50%;
			img {
				height: 62px;
			}
		}
		.doc-name {
			color: #333333;
			margin-right: 10px;
		}
		.box-title {
			color: #3385ed;
			line-height: 45px;
		}
		pre {
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #666666;
			line-height: 34px;
			white-space: pre-wrap;
			word-wrap: break-word;
		}
	}
}
</style>
